import { Box, SxProps, Theme } from "@mui/material";
import { FC } from "react";

interface LoadingChatsMessageProps {
  sx?: SxProps<Theme>;
}

export const LoadingChatsMessage: FC<LoadingChatsMessageProps> = ({ sx }) => (
  <Box
    sx={{
      px: 1,
      py: 0.5,
      color: "text.secondary",
      fontSize: "0.875rem",
      ...sx,
    }}
  >
    Loading chats...
  </Box>
);
